var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPiggyBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 105,
  fill: "#ffba00",
  r: 105,
  "data-original": "#ffba00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361 105C361 47.103 313.897 0 256 0v210c57.897 0 105-47.103 105-105z",
  fill: "#f5a000",
  "data-original": "#f5a000"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 105,
  fill: "#ffea98",
  r: 75,
  "data-original": "#ffea98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331 105c0-41.355-33.645-75-75-75v150c41.355 0 75-33.645 75-75z",
  fill: "#ffd845",
  "data-original": "#ffd845"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.352 97.436a268.358 268.358 0 01-4.394-1.592v-26.15c2.487.8 3.879 1.944 4.168 2.204a7.5 7.5 0 0012.041-8.935c-1.697-2.424-7.276-7.25-16.209-8.685V50c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v5.163c-.566.147-1.139.307-1.719.481-9.185 2.767-16.045 10.611-17.904 20.473-1.703 9.038 1.224 17.778 7.639 22.81 3.098 2.43 6.887 4.657 11.984 6.979v33.806c-3.794-.479-6.592-1.687-11.008-4.575a7.5 7.5 0 00-8.211 12.553c7.513 4.915 12.784 6.588 19.219 7.104V160c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-5.91c13.06-3.189 21.436-14.289 23.276-25.235 2.386-14.188-5.026-26.521-18.882-31.419zM245.23 87.124c-1.961-1.538-2.808-4.769-2.155-8.229.504-2.673 2.041-5.785 4.882-7.661v17.762a29.524 29.524 0 01-2.727-1.872zm26.211 39.244c-.761 4.525-3.638 9.298-8.484 11.82v-26.38c9.501 3.71 8.907 12.049 8.484 14.56z",
  fill: "#ffba00",
  "data-original": "#ffba00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.352 97.436a268.358 268.358 0 01-4.394-1.592v-26.15c2.487.8 3.879 1.944 4.168 2.204a7.5 7.5 0 0012.041-8.935c-1.697-2.424-7.276-7.25-16.209-8.685V50c0-3.959-3.07-7.194-6.958-7.473v124.945c3.888-.279 6.958-3.513 6.958-7.473v-5.91c13.06-3.189 21.436-14.289 23.276-25.235 2.386-14.187-5.026-26.52-18.882-31.418zm4.089 28.932c-.761 4.525-3.638 9.298-8.484 11.82v-26.38c9.501 3.71 8.907 12.049 8.484 14.56z",
  fill: "#f5a000",
  "data-original": "#f5a000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.088 277.183l-78.271-78.271 11.132-10.601c35.689-33.981 92.338-31.267 94.73-31.142 7.635.421 13.731 6.517 14.151 14.152.132 2.394 2.841 59.04-31.142 94.729z",
  fill: "#feaed6",
  "data-original": "#ffbca7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.912 277.183l-10.6-11.132c-33.983-35.688-31.274-92.335-31.142-94.729.421-7.635 6.517-13.731 14.151-14.152 2.392-.131 59.041-2.841 94.73 31.142l11.132 10.601z",
  fill: "#fec0e0",
  "data-original": "#ffcbbc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376 512h-60c-7.643 0-14.064-5.747-14.908-13.343l-6.223-56.004L391 402.807V497c0 8.284-6.716 15-15 15z",
  fill: "#feaed6",
  "data-original": "#ffbca7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 512h-60c-8.284 0-15-6.716-15-15v-94.193l96.131 39.846-6.223 56.004C210.064 506.253 203.643 512 196 512z",
  fill: "#fec0e0",
  "data-original": "#ffcbbc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 472c-50.812 0-91.64-9.862-121.353-29.313-17.105-11.197-30.344-25.555-39.349-42.675C85.811 381.976 81 360.775 81 337c0-96.495 78.505-175 175-175s175 78.505 175 175c0 23.775-4.811 44.976-14.298 63.012-9.005 17.12-22.244 31.478-39.349 42.675C347.64 462.138 306.812 472 256 472z",
  fill: "#ffd6e8",
  "data-original": "#ffddce"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.353 442.687c17.105-11.197 30.344-25.555 39.349-42.675C426.189 381.976 431 360.775 431 337c0-96.495-78.505-175-175-175v310c50.812 0 91.64-9.862 121.353-29.313z",
  fill: "#fec0e0",
  "data-original": "#ffcbbc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 412c-38.598 0-70-26.916-70-60s31.402-60 70-60 70 26.916 70 60-31.402 60-70 60z",
  fill: "#fec0e0",
  "data-original": "#ffcbbc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326 352c0-33.084-31.402-60-70-60v120c38.598 0 70-26.916 70-60z",
  fill: "#feaed6",
  "data-original": "#ffbca7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 262,
  fill: "#c558c0",
  r: 15,
  "data-original": "#646e7d"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 321,
  cy: 262,
  fill: "#8a409a",
  r: 15,
  "data-original": "#465064"
}))));
export default SvgPiggyBank;